import { Component, Input } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ScoresSportsService } from '../../../../services/scores-sports.service';
import { UtilitiesService } from '../../../../services/utilities.service';
import { SportsService } from '../../../../services/sport.service';
import { CommonModule } from '@angular/common';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { TranslateModule } from '@ngx-translate/core';
import { ScoresSportsTeamComponent } from '../../../../components/shared/scores-sports-team/scores-sports-team.component';
import { ScoresFootballTeamComponent } from '../../../../components/shared/scores-football-team/scores-football-team.component';
import { NoResultComponent } from '../../../../components/shared/no-result/no-result.component';

@Component({
  selector: 'app-lastes-matches',
  standalone: true,
  imports: [
    CommonModule,
    NzSkeletonComponent,
    TranslateModule,
    ScoresSportsTeamComponent,
    ScoresFootballTeamComponent,
    NoResultComponent
  ],
  templateUrl: './lastes-matches.component.html',
  styleUrl: './lastes-matches.component.scss',
})
export class LastesMatchesComponent {
  @Input() idCompetition: string = '';
  @Input() type: string = 'Competition';

  dashboardCompetitionsLast: Array<{
    date: string;
    dateSearch: string;
    data: any;
    load: boolean;
  }> = [];
  filterSelected: any = 'All';
  loaderMatches = true;

  urlSVG = environment.urlIcon;
  urlIMG = environment.urlIMG;

  constructor(
    private scoresServices: ScoresSportsService,
    public utilityService: UtilitiesService,
    public readonly sportsServices: SportsService
  ) {}

  ngOnChanges(): void {
    this.loaderMatches = true;
    this.loadDashboard(this.idCompetition);
  }

  private loadDashboard(id: string) {
    this.dashboardCompetitionsLast = [];
    for (let i = 0; i < 5; i++) {
      const date = new Date();
      date.setDate(date.getDate() - (i + 1));

      const dateSearch =
        date.getFullYear() +
        String(date.getMonth() + 1).padStart(2, '0') +
        String(date.getDate()).padStart(2, '0');

      const formattedDate =
        String(date.getDate()).padStart(2, '0') +
        '-' +
        String(date.getMonth() + 1).padStart(2, '0') +
        '-' +
        date.getFullYear();

      this.dashboardCompetitionsLast.push({
        date: formattedDate,
        dateSearch,
        data: [],
        load: true,
      });
    }

    this.loaderMatches = false;
    this.dashboardCompetitionsLast.forEach((elem: any) => {
      this.scoresServices
        .getScheduleResultsById(
          elem.dateSearch,
          'All',
          this.idCompetition,
          this.type,
          false
        )
        .subscribe(
          (response: any) => {
            if (response.status) {
              elem.data = response.data;
              elem.load = false;
            } else elem.load = false;
          },
          () => {
            elem.data = [];
            elem.load = false;
          }
        );
    });
  }
}
